import store from '../store'
import { apiService } from './apiService'

export const fetchTranslation = async ({ transcript, targetLanguage, transcriptType, signal }) => {
  const { username, organizationid, token } = store.getState().currentUser

  const response = await fetch(`${apiService.summary}/translate`, {
    method: 'POST',
    body: JSON.stringify({
      transcript,
      target_language: targetLanguage,
      transcript_type: transcriptType,
    }),
    headers: {
      'Content-Type': 'application/json',
      'auth-type': 'web',
      username,
      organizationid,
      token,
    },
    signal,
  })

  if (!response.ok) {
    let errorMessage = 'Failed to translate transcript'
    try {
      const errorData = await response.json()
      if (errorData.detail) {
        errorMessage = errorData.detail
      }
    } catch {
      // use the default message
    }
    throw new Error(errorMessage)
  }

  const reader = response.body.getReader()
  const decoder = new TextDecoder()
  let result = ''

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read()
    if (done) {
      break
    }
    result += decoder.decode(value, { stream: true })
  }

  let parsed
  try {
    parsed = JSON.parse(result)
  } catch {
    throw new Error('Failed to parse translation response')
  }

  return parsed.transcript
}
